package de.ohhhmhhh.frontend.admin.ui.screens.revocation

import androidx.compose.runtime.Composable
import de.ohhhmhhh.backend.models.model.revocation.RevocationContractTypeEntity
import de.ohhhmhhh.backend.models.model.revocation.RevocationStateEntity
import de.ohhhmhhh.frontend.admin.helper.Formats
import de.ohhhmhhh.frontend.admin.ui.components.buttons.Button
import de.ohhhmhhh.frontend.admin.ui.components.container.Page
import de.ohhhmhhh.frontend.admin.ui.components.container.Row
import de.ohhhmhhh.frontend.admin.ui.components.inputs.SearchInput
import de.ohhhmhhh.frontend.admin.ui.components.other.*
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.offsetAt
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun RevocationListPageContent(
    state: RevocationListState,
    onSearch: (String?) -> Unit,
    onSetContractType: (RevocationContractTypeEntity?) -> Unit,
    onSetState: (RevocationStateEntity?) -> Unit,
    onUpdateState: (String, RevocationStateEntity) -> Unit,
    onReset: () -> Unit,
    onSetPage: (Int) -> Unit,
) {
    Page("Widerrufe") {
        Row {
            SearchInput(state.search, onSearch)
            SimpleSelect(RevocationContractTypeSelectAdapter, state.contractType) {
                onSetContractType(it)
            }
            SimpleSelect(RevocationStateSelectAdapter, state.state) {
                onSetState(it)
            }
            Button("Zurücksetzen", attrs = { classes("ms-auto") }, onClick = onReset)
        }
        Spacer()
        Div({ style { flexGrow(1) } }) {
            Table(
                headers = listOf(
                    "Status",
                    "Absender",
                    "Nachricht",
                    "Vertragsart",
                    "Vertragsnummer",
                    "Erstellt am",
                    "Abgeschlossen am"
                ),
                items = state.items,
                options = listOf("Genehmigen", "Ablehnen", "Zurücksetzen"),
                onOption = { item, option ->
                    if (option == "Genehmigen" && item.state == RevocationStateEntity.OPEN) {
                        onUpdateState(item.id, RevocationStateEntity.APPROVED)
                    }

                    if (option == "Ablehnen" && item.state == RevocationStateEntity.OPEN) {
                        onUpdateState(item.id, RevocationStateEntity.REJECTED)
                    }

                    if (option == "Zurücksetzen" && item.state != RevocationStateEntity.OPEN) {
                        onUpdateState(item.id, RevocationStateEntity.OPEN)
                    }
                },
                attrs = { classes("revocation-table") }
            ) { item, _, column ->
                when (column) {
                    0 -> when (item.state) {
                        RevocationStateEntity.OPEN -> YellowBadge("Offen")
                        RevocationStateEntity.APPROVED -> GreenBadge("Genehmigt")
                        RevocationStateEntity.REJECTED -> RedBadge("Abgelehnt")
                    }

                    1 -> {
                        Text(item.firstName + " " + item.lastName)
                        Br()
                        Text(item.emailAddress)
                    }

                    2 -> Text(item.message ?: "-")
                    3 -> Text(
                        when (item.contractType) {
                            RevocationContractTypeEntity.SHOP_ORDER -> "Shop (Bestellung)"
                            RevocationContractTypeEntity.SHOP_ITEMS -> "Shop (Artikel)"
                            RevocationContractTypeEntity.VOUCHER -> "Gutschein"
                            RevocationContractTypeEntity.SUBSCRIPTION -> "Abonnement"
                        }
                    )
                    4 -> Text(item.contractId)
                    5 -> {
                        val offset = TimeZone.currentSystemDefault().offsetAt(item.created)
                        Text(item.created.format(Formats.Instant.dateTime, offset))
                    }
                    6 -> {
                        val text = item.completed?.let {
                            val offset = TimeZone.currentSystemDefault().offsetAt(it)
                            it.format(Formats.Instant.dateTime, offset)
                        } ?: "-"
                        Text(text)
                    }
                }
            }
        }
        ResultCount(state.resultCount)
        Spacer()
        Pager(state.page, state.pageCount, onSetPage)
    }
}

private val RevocationContractTypeSelectAdapter = EnumSelectAdapter<RevocationContractTypeEntity> {
    when (it) {
        RevocationContractTypeEntity.SHOP_ORDER -> "Shop (Bestellung)"
        RevocationContractTypeEntity.SHOP_ITEMS -> "Shop (Artikel)"
        RevocationContractTypeEntity.VOUCHER -> "Gutschein"
        RevocationContractTypeEntity.SUBSCRIPTION -> "Abonnement"
    }
}

private val RevocationStateSelectAdapter = EnumSelectAdapter<RevocationStateEntity> {
    when (it) {
        RevocationStateEntity.OPEN -> "Offen"
        RevocationStateEntity.APPROVED -> "Genehmigt"
        RevocationStateEntity.REJECTED -> "Abgelehnt"
    }
}
